import React from 'react';
import {useSelector,useDispatch} from 'react-redux';
import * as actionTypes from '../../../redux/actions/actionTypes';
import HeaderStep from '../../../components/HeaderStep/HeaderStep';
import stylesForm from '../Form/Form.module.scss';
import LabelUpload from '../../../components/LabelUpload/LabelUpload';
import { Form, Button } from 'antd';
// import Navigation from '../../Navigation/Navigation';
import styleCaricamentoDocumenti from './CaricamentoDocumentiSecondari.module.scss';
import stylesRiepilogo from '../12__Riepilogo/Riepilogo.module.scss';
import Immagine from '../../../components/Immagine/Immagine';
import {invioDocumentiPriority2} from '../../../redux/actions/mock/invioDocumenti';
import {salvaCurrentStep} from '../../../redux/actions/mock/salvaStep';

const CaricamentoDocumentiSecondari = () => {

    const datiState = useSelector(state => state.dataReducer || '');
    const attivita = datiState.modello.datiPratica.attivita || '';
    const uuid = useSelector(state => state.dataReducer.modello.id);
    const apiPath = useSelector(state => state.dataReducer.dataApiPath);
    const healthDocUploaded = datiState.load.healthDocUploaded;
    const incomeDocUploaded = datiState.load.incomeDocUploaded;
    const loadingConferma = datiState.load.loadingConferma;


    const dispatch = useDispatch();

    function onFinish(values){
        dispatch({type: actionTypes.LOADING_CONFERMA_TRUE});
        dispatch({ type: actionTypes.SALVA_DOCUMENTI, payload: values});
        dispatch(salvaCurrentStep(uuid, apiPath, 15));
        dispatch(invioDocumentiPriority2(uuid,apiPath));
    };
    
    const onFinishFailed = (errorInfo) => {
    };

    return (
        <div className={stylesForm.Form}>

            <HeaderStep titolo='Caricamento documenti' sottotitolo ='' />

            <p className={styleCaricamentoDocumenti.Paragrafo}>Puoi fare una foto dei documenti o caricare file .pdf, .jpeg, .png di dimensioni inferiori a 3 MB</p>

            <Form name="step13"  onFinish={onFinish} onFinishFailed={onFinishFailed}>

                <LabelUpload file="tesserinoSanitario" />

                { (attivita === 'S') ? (

                    <LabelUpload file="modelloUnico" />

                ) : (attivita === 'D') ? (

                    <LabelUpload file="cedolino" />
                
                ) : (attivita === 'P') ? (

                    <LabelUpload file="pensione" />

                ) : null
                }

                <div className={stylesRiepilogo.bottoniRiepilogo}>
                    <Button loading={loadingConferma} htmlType="submit" className={stylesRiepilogo.BottoneAvanti} disabled={!(healthDocUploaded && incomeDocUploaded)}>Invia Documenti <Immagine urlImage={'right.svg'} name='Invia Richiesta' /></Button>
                </div>

            </Form>
        </div>
    )
}

export default CaricamentoDocumentiSecondari;